/* eslint-disable max-len */
import React from 'react'
import SliderSlick from 'react-slick'
import { translate } from 'react-translate'
import { browserHistory } from 'react-router'

import './ServicesWidget.scss'

function ServicesWidgetComponent ({ services, currentPurpose }) {
  const sliderSettings = {
    dots: false,
    lazyLoad: 'progressive',
    arrows: false,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchMove: true,
  }

  const handleClickServices = (index, sectorId) => browserHistory.push(`/servicios?seleccion=${currentPurpose}&index=${index}&sector=${sectorId}`)

  return <div className='ljr-services-widget-container'>
    <div className='ljr-services-widget'>
      {services && !!services.length && <SliderSlick className='slider-banners-container' {...sliderSettings}>
        {services.map((service, index) => (<div key={index} className='ljr-services-item'>
            <h2 onClick={() => handleClickServices(index, service.sectorId)}>{service.title}</h2>
            <h3 onClick={() => handleClickServices(index, service.sectorId)}>{service.subTitle}</h3>
            <div>
              <p onClick={() => handleClickServices(index, service.sectorId)}>
                {service.content}
              </p>
            </div>
          </div>)
        )}
      </SliderSlick>}
    </div>
  </div>
}

const ServicesWidget = translate('ServicesWidget')(ServicesWidgetComponent)

export {
  ServicesWidget,
}



// WEBPACK FOOTER //
// ./src/features/commons/ServicesWidget/ServicesWidget.component.js